import Vue from 'vue'
import Router from 'vue-router'
import AuthGuard from './auth-guard'
import Home from '@/components/Home'
import Deals from '@/components/Deals'
import Hwod from '@/components/Hwod'
import UserSignup from '@/components/user/Signup'
import UserSignin from '@/components/user/Signin'
import Account from '@/components/user/Account'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/deals',
      name: 'Deals',
      component: Deals
    },
    {
      path: '/hotwingsofdestiny',
      name: 'Hot Wings Of Destiny',
      component: Hwod,
      beforeEnter: AuthGuard
    },
    {
      path: '/user/signup',
      name: 'User Signup',
      component: UserSignup
    },
    {
      path: '/user/signin',
      name: 'User Signin',
      component: UserSignin
    },
    {
      path: '/user/:id',
      name: 'Account',
      props: true,
      component: Account,
      beforeEnter: AuthGuard
    }
  ]
})
 


// WEBPACK FOOTER //
// ./src/router/index.js